import { settings } from '../config';
import { Event, Part, MyLineTask, TaskNotesByBarcodeResponse, TaskNote } from '../types/tasks';
import { getToken } from './../global/TokenValidator';

class Tasks {
  GetTasksOnCalendar = async (woNumber: string): Promise<{ status: Boolean, data: Event[] }> => {
    return fetch(`${settings.HOST}/ScheduleTasks/GetTasksOnCalendar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
      body: JSON.stringify({
        wo_number: woNumber
      })
    }).then(x => {
      return x.json()
    })
  }
  GetLineTasksForMe = async (): Promise<{ status: Boolean, data: MyLineTask[] }> => {
    return fetch(`${settings.HOST}/Line/GetLineTasksForMe `, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
    }).then(x => {
      return x.json()
    })
  }
  GetAllBayTasksForMe = async (): Promise<{ status: Boolean, message: Boolean, data: Event[] }> => {
    return fetch(`${settings.HOST}/ScheduleTasks/GetAllBayTasksForMe`, {
      method: 'Get',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
    }).then(x => {
      return x.json()
    })
  }
  GetAllPartsByTaskBarcode = async (barcode: string): Promise<{ status: Boolean, data: Part[] }> => {
    return fetch(`${settings.HOST}/Parts/GetAllPartsByTaskBarcode/${barcode}`, {
      method: 'Get',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
    }).then(x => {
      return x.json()
    })
  }
  GetPartsByWoBarcode = async (wo_number: string): Promise<{ data: Part[] }> => {
    return fetch(`${settings.HOST}/packet/GetPartsByWoBarcode/${wo_number}`, {
      method: 'Get',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
    }).then(x => {
      return x.json()
    })
  }
  GetAllTailNumbers = async (): Promise<{ status: Boolean, data: string[] }> => {
    return fetch(`${settings.HOST}/ScheduleTasks/GetAllTailNumbers`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
    }).then(x => {
      return x.json()
    })
  }

  // Task Notes API Methods
  GetTaskNotes = async (taskBarcode: string): Promise<{ status: boolean, message: string, data: TaskNote[] }> => {
    return fetch(`${settings.HOST}/Tasks/GetTaskNotes/${taskBarcode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
    }).then(x => x.json());
  };

  GetTaskNotesByBarcodes = async (taskBarcodes: string[]): Promise<TaskNotesByBarcodeResponse> => {
    return fetch(`${settings.HOST}/Tasks/GetTaskNotesByBarcodes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
      body: JSON.stringify(taskBarcodes)
    }).then(x => x.json());
  };

  CreateTaskNote = async (taskBarcode: string, text: string): Promise<{ status: boolean, message: string }> => {
    return fetch(`${settings.HOST}/Tasks/CreateTaskNote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
      body: JSON.stringify({
        taskBarcode,
        text
      })
    }).then(x => x.json());
  };

  EditTaskNote = async (noteId: number, text: string): Promise<{ status: boolean, message: string }> => {
    return fetch(`${settings.HOST}/Tasks/EditTaskNote`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
      body: JSON.stringify({
        noteId,
        text
      })
    }).then(x => x.json());
  };

  DeleteTaskNote = async (noteId: number): Promise<{ status: boolean, message: string }> => {
    return fetch(`${settings.HOST}/Tasks/DeleteTaskNote`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'apikey': settings.KONG_KEY,
        'token': await getToken(),
      },
      body: JSON.stringify({
        noteId
      })
    }).then(x => x.json());
  };

}
const TasksApi = new Tasks();
export default TasksApi;